const SourceScenarioEnum = Object.freeze({
  SCENARIO_SDK_API: 'sdk-api',
  SCENARIO_EXTERNAL_API: 'external-api',
  SCENARIO_IMPORT: 'import',
  SCENARIO_INTEGRATION: 'integration'
})

export { SourceScenarioEnum }



// WEBPACK FOOTER //
// ./src/common/enum/SourceScenarioEnum.js